/**
 * Job listings: client-side search, filter, and sort.
 */
(() => {
	const openingLabel = (count) =>
		count === 1 ? `${count} opening` : `${count} openings`;

	const compareText = (a, b) =>
		a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true });

	const init = (root) => {
		const body = root.querySelector('[data-job-listings-body]');
		const countEl = root.querySelector('[data-job-listings-count]');
		const noneEl = root.querySelector('[data-job-listings-none]');
		const search = root.querySelector('[data-job-listings-search]');
		const company = root.querySelector('[data-job-listings-company]');
		const location = root.querySelector('[data-job-listings-location]');
		const sort = root.querySelector('[data-job-listings-sort]');

		if (!body) {
			return;
		}

		const rows = Array.from(body.querySelectorAll('.job-listings__row'));

		const apply = () => {
			const q = (search?.value || '').trim().toLowerCase();
			const companyVal = company?.value || '';
			const locationVal = location?.value || '';
			const sortVal = sort?.value || 'date-desc';

			const visible = rows.filter((row) => {
				if (companyVal && row.dataset.company !== companyVal) {
					return false;
				}
				if (locationVal && row.dataset.location !== locationVal) {
					return false;
				}
				if (q && !(row.dataset.search || '').includes(q)) {
					return false;
				}
				return true;
			});

			visible.sort((a, b) => {
				switch (sortVal) {
					case 'date-asc':
						return Number(a.dataset.date || 0) - Number(b.dataset.date || 0);
					case 'title-asc':
						return compareText(a.dataset.title || '', b.dataset.title || '');
					case 'title-desc':
						return compareText(b.dataset.title || '', a.dataset.title || '');
					case 'company-asc':
						return compareText(a.dataset.company || '', b.dataset.company || '');
					case 'location-asc':
						return compareText(a.dataset.location || '', b.dataset.location || '');
					case 'date-desc':
					default:
						return Number(b.dataset.date || 0) - Number(a.dataset.date || 0);
				}
			});

			rows.forEach((row) => {
				row.hidden = true;
			});
			visible.forEach((row) => {
				row.hidden = false;
				body.appendChild(row);
			});

			if (countEl) {
				countEl.textContent = openingLabel(visible.length);
			}
			if (noneEl) {
				noneEl.hidden = visible.length > 0;
			}
		};

		['input', 'change'].forEach((eventName) => {
			root.querySelector('[data-job-listings-controls]')?.addEventListener(eventName, apply);
		});

		root.querySelector('[data-job-listings-controls]')?.addEventListener('submit', (event) => {
			event.preventDefault();
			apply();
		});

		apply();
	};

	document.querySelectorAll('[data-job-listings]').forEach(init);
})();
